import compose from 'recompose/compose';
import { connect } from 'react-redux';
import ConversionForm from './ConversionForm';

export default compose(
  connect(
    (state) => ({
      listConversionType: state.catalogs.conversionType.list,
    }),
    {}
  )
)(ConversionForm);
